
<template>
  <div>
    <wc-kan-board-header :headerConfig="JSON.stringify(headerConfig)" @kan-board-header-menuresponse="kanBorarHeaderResponse" :key="eid"></wc-kan-board-header>
    <!-- <decsisionSupportVegaHeader :title="fullName" @updatelocalInfo="updatelocalInfo"></decsisionSupportVegaHeader> -->
    <div class="data-view">
      <div class="dv-full-screen-container">
        <v-row style="width:100%">
          <v-col cols="12" style="padding: 0 12px;">
            <decision :key="eid" v-if="eid != ''" id="vegaView" ref="myvegaView" :eid="eid" :companyfullName="fullName">
            </decision>
          </v-col>
        </v-row>
      </div>
    </div>
    <dialogJsonForms></dialogJsonForms>
    <dialogKanBoard></dialogKanBoard>
    <!--本地资料-->
    <localuploadFile ref="mylocaluploadFile"></localuploadFile>
    <localuploadFolder ref="mylocaluploadFolder"></localuploadFolder>
    <!--弹窗-->
    <dialogprodVega ref="myprodVega"></dialogprodVega>
    <dialogIntensive></dialogIntensive>
    <dialogChangeVega></dialogChangeVega>
    <dialogVega></dialogVega>
    <changeEid ref="mychangeEid"></changeEid>
    <vxe-modal v-model="dialogRun" :title="dialogtitle" width="500px" height="300px" show-zoom resize transfer>
      <div style="text-align: center;">
        <p>请到移动端订阅开通</p>
        <img :src="qrcode" class="qrcode" />
      </div>
    </vxe-modal>
  </div>
</template>

<script>
 //  import decsisionSupportVegaHeader from "./components/decsisionSupportVegaHeader.vue";
  import qrcode from "@/assets/img/common/qrcode.png";
  import apiAxios from "@/config/apiAxios";
  import decision from "./components/decision.vue";
  import userDocApi from "@/assets/js/userDocApi.js";
  import XEUtils from "xe-utils";
  import dialogJsonForms from "@/components/common/dialogJsonForms.vue";
  import dialogKanBoard from "@/components/common/dialogKanBoard.vue";
  import dialogprodVega from "./components/dialogprodVega.vue";
  import changeEid from "./components/changeEid.vue";
  import localuploadFile from "./components/localuploadFile.vue";
  import localuploadFolder from "./components/localuploadFolder.vue";
  import dialogIntensive from "@/components/common/dialogIntensive"
  import dialogChangeVega from "@/components/common/dialogChangeVega"
  import dialogVega from "@/components/common/dialogVega"
  export default {
    name: "smartAnalyze",
    components: {
      decision,
    //  decsisionSupportVegaHeader,
      dialogJsonForms,
      dialogKanBoard,
      dialogprodVega,
      changeEid,
      localuploadFile,
      localuploadFolder,
      dialogIntensive,
      dialogChangeVega,
      dialogVega
    },
    data() {
      return {
        eid: "",
        fullName: "",
        LocalData: [],
        isExistLocalData: false,
        headerConfig: {
          kanboardname: "小智分析-ESG",
          logo: "https://test.cmdp.cn/plus/plugins/web/img/site-logo.svg",
          menuConfig: [{
              name: "上传本地资料",
              icon: "mysvg:upload",
              code: "localuploadFile",
              apitype: "",
              apiId: "",
              params: {},
              disabled: false,
              responseMode: "throw",
              tooltip: "",
              // children: [{
              //     name: "上传文件",
              //     //  icon: "mysvg:keyStar",
              //     code: "localuploadFile",
              //     apitype: "",
              //     apiId: "",
              //     params: {},
              //     disabled: false,
              //     responseMode: "throw",
              //     tooltip: ""
              //   },
              //   {
              //     name: "上传项目",
              //     //   icon: "mysvg:wifiOff",
              //     code: "localuploadFloder",
              //     apitype: "",
              //     apiId: "",
              //     params: {},
              //     disabled: false,
              //     responseMode: "throw",
              //     tooltip: ""
              //   }
              // ]
            },
            {
              name: "情报订阅",
              icon: "mysvg:playlistCheck",
              code: "infoSub",
              apitype: "",
              apiId: "",
              params: {},
              disabled: false,
              responseMode: "throw",
              tooltip: ""
            },
            {
              name: "智库甄选",
              icon: "mysvg:angularjs",
              code: "tankSelection",
              apitype: "",
              apiId: "",
             // params: {tags:['prod_cmdp_plus_recommend']},
             params:{tags:[
          "scene_oppty,scene_oppty,scene_profession,scene_warning"
]},
              disabled: false,
              responseMode: "throw",
              tooltip: ""
            },
            // {
            //   name: "预测魔方",
            //   icon: "mysvg:autoFix",
            //   code: "predCube",
            //   apitype: "",
            //   apiId: "",
            //   params: {tags:['prod_cmdp_plus_predict']},
            //   disabled: false,
            //   responseMode: "throw",
            //   tooltip: ""
            // },
            // {
            //   name: "小智助手",
            //   icon: "mysvg:handshake",
            //   code: "assistant",
            //   apitype: "",
            //   apiId: "",
            //   params: {tags:['prod_cmdp_plus_assist']},
            //   disabled: false,
            //   responseMode: "throw",
            //   tooltip: ""
            // },
            {
              name: "定制",
              icon: "mysvg:keyStar",
              code: "",
              apitype: "",
              apiId: "",
              params: {},
              disabled: false,
              responseMode: "",
              tooltip: "",
              children: [{
                  name: "私有化",
                  icon: "mysvg:keyStar",
                  code: "priv",
                  apitype: "",
                  apiId: "",
                  params: {},
                  disabled: false,
                  responseMode: "throw",
                  tooltip: ""
                },
                {
                  name: "离线",
                  icon: "mysvg:wifiOff",
                  code: "offline",
                  apitype: "",
                  apiId: "",
                  params: {},
                  disabled: false,
                  responseMode: "throw",
                  tooltip: ""
                }
              ]
            },
            {
              name: "反馈",
              icon: "mysvg:feedBack",
              tooltip: "",
              code: "feedBack",
              apitype: "",
              apiId: "",
              params: {},
              disabled: false,
              responseMode: "throw"
            },
            {
              name: "消息中心",
              icon: "mysvg:message",
              tooltip: "消息中心",
              hidename: true,
              code: "message",
              apitype: "",
              apiId: "",
              params: {},
              disabled: false,
              responseMode: "throw"
            },
            {
              name: "account",
              icon: "mysvg:account",
              tooltip: "",
              hidename: true,
              code: "account",
              apitype: "",
              apiId: "",
              params: {},
              disabled: false,
              responseMode: "",
              children: [{
                  name: "切换其他公司",
                  tooltip: "",
                  code: "changeEid",
                  apitype: "",
                  apiId: "",
                  params: {},
                  disabled: false,
                  responseMode: "throw"
                },
                {
                  name: "退出帐号",
                  tooltip: "",
                  code: "loginOut",
                  apitype: "",
                  apiId: "",
                  params: {},
                  disabled: false,
                  responseMode: "throw"
                }
              ]
            }
          ]
        },
        qrcode:qrcode,
        dialogRun:false,
        dialogtitle:""

      };
    },
    methods: {
      // 选中
      btnSelect(val) {
        if (val == "" || val == null) {
          return;
        }
        let _conf = val.split("+");
        this.eid = _conf[0];
        this.fullName = _conf[1];
        this.getLocalData();
      },
      // 查找用户本地资源
      getLocalData() {
        let path = `md/cmdp专业版用户上传本地资料/${
          this.fullName
        }/localuploadFileInfo.json`;
        userDocApi.getFileContextByPath(path, "application/json", _r => {
          // 父级目录不存在
          if (_r.code == 404) {} else {
            this.isExistLocalData = true;
            this.LocalData = XEUtils.clone(_r, true);
            this.$refs.myvegaView.updateLocal(_r);
          }
        });
      },
      // 创建上传目录
      createFolder() {
        let path = `md`;
        let name = "cmdp专业版用户上传本地资料";
        userDocApi.createFolder(path, name, _r => {
          console.log(_r);
        });
      },
      // 上传文件更新本地资料
      updatelocalInfo(params) {
        if (params) {
          let res = [];
          let that = this;
          params.map(function(d) {
            let obj = {};
            obj.eid = that.eid;
            obj.eventName = d.label;
            obj.eventTime = $func.getToday(true);
            obj.reportId = d.fileName;
            obj.bizType = "";
            obj.path = d.path;
            obj.fid = d.fid;
            if (d.folderName) {
              obj.folderName = d.folderName;
            }
            if (d.folderLen) {
              obj.folderLen = d.folderLen;
            }
            if (d.status) {
              obj.status = d.status;
            }
            res.push(obj);
          });
          let jsonstr = that.LocalData.concat(res);
          // 不存在，新增
          if (!this.isExistLocalData) {
            userDocApi.createJsonFile(
              `md/cmdp专业版用户上传本地资料/${this.fullName}`,
              "localuploadFileInfo.json",
              jsonstr, {
                hiddenStatus: 0
              },
              _r => {
                if (_r.code == 200) {
                  that.getLocalData();
                }
              }
            );
          } else {
            let fileParam = {
              type: "1",
              content: new File(
                [JSON.stringify(jsonstr)],
                "localuploadFileInfo.json"
              ),
              label: "localuploadFileInfo.json"
            };
            // 存在更新
            userDocApi.editFile(
              `md/cmdp专业版用户上传本地资料/${
                this.fullName
              }/localuploadFileInfo.json`,
              fileParam,
              _r => {
                if (_r.code == 200) {
                  that.getLocalData();
                }
              }
            );
          }
        }
      },
      // 删除本地资料，删除
      deletelocalFile(data) {
        let eventtime = $func.formatDate(data.eventTime, "yyyy-MM-DD HH:mm:ss");
        XEUtils.remove(
          this.LocalData,
          x => x.fid == data.fid && x.eventTime == eventtime
        );
        let fileParam = {
          type: "1",
          content: new File(
            [JSON.stringify(this.LocalData)],
            "localuploadFileInfo.json"
          ),
          label: "localuploadFileInfo.json"
        };
        // 存在更新
        userDocApi.editFile(
          `md/cmdp专业版用户上传本地资料/${
            this.fullName
          }/localuploadFileInfo.json`,
          fileParam,
          _r => {
            if (_r.code == 200) {
              this.getLocalData();
              this.$notify({
                type: "success",
                message: "删除成功"
              });
            } else {
              this.$notify({
                type: "danger",
                message: "删除失败！"
              });
            }
          }
        );
      },
      // 删除本地资料，删除
      deletelocalfolder(data) {
        XEUtils.remove(this.LocalData, x => x.folderName === data.name);
        let fileParam = {
          type: "1",
          content: new File(
            [JSON.stringify(this.LocalData)],
            "localuploadFileInfo.json"
          ),
          label: "localuploadFileInfo.json"
        };
        // 存在更新
        userDocApi.editFile(
          `md/cmdp专业版用户上传本地资料/${
            this.fullName
          }/localuploadFileInfo.json`,
          fileParam,
          _r => {
            if (_r.code == 200) {
              this.getLocalData();
              this.$notify({
                type: "success",
                message: "删除成功"
              });
            } else {
              this.$notify({
                type: "danger",
                message: "删除失败！"
              });
            }
          }
        );
      },
      initPage() {
        let lcEid = JSON.parse(localStorage.getItem("decsisionSupportCurPara"));
        if (lcEid) {
          this.eid = lcEid.eid;
          this.fullName = lcEid.fullName;
          this.headerConfig.kanboardname="小智分析-"+ this.fullName;
          document.title= this.headerConfig.kanboardname;
          // this.$refs.myvegaView.vegaInit()
          this.getLocalData();
        } else {
          let _userInfo = JSON.parse(sessionStorage.getItem("USER_INFO"));
          let _userEid = localStorage.getItem("_userEid");
          if (_userEid) {
            this.eid = _userEid;
            this.fullName = _userInfo.company;
            this.headerConfig.kanboardname="小智分析-"+ this.fullName;
            document.title= this.headerConfig.kanboardname;
          } else {
            let url = `${config.serverUrl}/apm/v1/ability/DA000030?name=${
              _userInfo.company
            }`;
            apiAxios.get(url, {}, _r => {
              if (_r.code == 200) {
                if (_r.data.eid) {
                  let eid = _r.data.eid;
                  this.eid = eid;
                  this.fullName = _userInfo.company;
                  this.headerConfig.kanboardname="小智分析-"+ this.fullName;
                  document.title= this.headerConfig.kanboardname;
                  localStorage.setItem("_userEid", eid);
                  localStorage.setItem(
                    "decsisionSupportCurPara",
                    JSON.stringify({
                      eid: eid,
                      fullName: _userInfo.company
                    })
                  );
                  this.getLocalData();
                }
              }
            });
          }
        }
      },
      /**
       * 相应看板头部事件
       */
      kanBorarHeaderResponse(e) {
        let data = e.detail.data;
        let code = data.code;
        switch (code) {
          case "localuploadFile":
          this.$refs.mylocaluploadFile.init(this.fullName)
            break;
            case "localuploadFloder":
            this.$refs.mylocaluploadFolder.init(this.fullName)
            break;
          case "tankSelection" :
          case "predCube":
          case "assistant":
          this.$refs.myprodVega.getTableData(data.params.tags, data.name);
          break;
          case "priv":
          case "offline":
          this.dialogtitle=data.name + "使用";
          this.dialogRun=true;
          break;
          case "changeEid":
          this.$refs.mychangeEid.showDialog();
          break;
          case "message":
          this.$EventBus.$emit('opendialogTaskCenter');
          break;
          default:
          this.$notify({ type: 'danger', message: '功能开发中' })
          break;
        }
      }
    },
    mounted() {
      // 先判断eid是否存在
      let hasPrimission = sessionStorage.getItem("USER_ISMATCHTAG");
      if (hasPrimission) {
        this.initPage();
      }
      // let val = this.$route.query.val;
      // if (val) {
      //   this.btnSelect(val)
      // }
    },
    created() {
      // this.$store.dispatch('setSiteHeaderIconColor', '#fff')
      // this.$store.dispatch('setIsShowSiteHeader', false)
      this.$EventBus.$on("changeEid", e => {
        this.eid = e.eid;
        this.fullName = e.fullName;
        this.headerConfig.kanboardname="小智分析-"+ e.fullName;
        document.title= this.headerConfig.kanboardname;
        localStorage.setItem(
          "decsisionSupportCurPara",
          JSON.stringify({
            eid: e.eid,
            fullName: e.fullName
          })
        );
        // this.$refs.myvegaView.changeEid(this.eid);
        this.$refs.myvegaView.vegaInit();
        this.isExistLocalData = false;
        this.LocalData = [];
        this.getLocalData();
        // console.log(e);
      });
      this.$EventBus.$on("updatelocalInfo", e => {
        if (e.type == "files") {
          // 上传本地资料
          this.updatelocalInfo(e.fileList);
        } else if (e.type == "folders") {
          this.updatelocalInfo(e.fileList);
          // 上传项目
        }
        // console.log(e);
      });
      // 相应删除文件，然后更新视图
      this.$EventBus.$on("deletelocalfile", e => {
        if (e.type == "files") {
          this.deletelocalFile(e.data);
        } else if (e.type == "folders") {
          this.deletelocalfolder(e.data);
        }
      });
    }
  };
</script>

<style lang="less" scoped>
  .mobileContainer {
    max-width: 60vw;
    margin: 10vh auto;
  }
  .hotsearch {
    width: 100%; // height: 56px;
    margin-top: 32px;
    text-align: left; // font-size: 0;
    // color: @workbench-background-color;
    overflow: hidden;
  }
  .keys {
    // padding-left: 20px;
    display: inline-block;
    height: 56px;
    vertical-align: top;
    text-align: left;
  }
  .el-link {
    // color: #font-color[light];
    display: inline-block;
    vertical-align: top;
    margin-right: 24px;
    margin-bottom: 10px; // font-size: #font-size[normal];
    line-height: 22px;
  }
  .qrcode{
    width:auto;
    height: auto;
}
</style>

